import { MutationTree } from 'vuex'
import { EstadoComponentes } from "./estadoComponentes"

const state: EstadoComponentes = {
    sidebarIsOpened: false,
    modalImpressaoIsOpened: false,
    modalNotificacaoIsOpened: false,
    modalUsuarioIsOpened: false,
    modalUsuarioPortalIsOpened: false,
    modalHistoricoIsOpened: false,
    bloquearacessoatrasos:false,
    totalNotificacao: 0,
    totalMensagens: 0    
};

const mutations: MutationTree<EstadoComponentes> = {
    HANDLE_RESIZE(state) {
        if(state.bloquearacessoatrasos){
            state.sidebarIsOpened = false;   
            return;
        }else{
            if (document?.activeElement?.hasAttribute('insideSidebar')) {
                return;
            }
            state.sidebarIsOpened = (window.innerWidth > 1023);
        }

    },
    SET_USUARIOBLOQUEADO(state, bloqueado) {
        state.bloquearacessoatrasos = bloqueado
    },    
    SET_SIDEBAR(state, isOpened) {
        state.sidebarIsOpened = isOpened
    },
    OPEN_MODAL_IMPRESSAO(state) {
        if (!state.modalImpressaoIsOpened) {
            state.modalImpressaoIsOpened = true
        }
    },
    TOGGLE_MODAL_IMPRESSAO(state) {
        state.modalImpressaoIsOpened = !state.modalImpressaoIsOpened
    },
    TOGGLE_MODAL_NOTIFICACAO(state) {
        state.modalNotificacaoIsOpened = !state.modalNotificacaoIsOpened
    },
    SET_MODAL_NOTIFICACAO(state, isOpened) {
        state.modalNotificacaoIsOpened = isOpened
    },
    TOGGLE_MODAL_USUARIO(state) {
        state.modalUsuarioIsOpened = !state.modalUsuarioIsOpened
    },
    SET_MODAL_USUARIO(state, isOpened) {
        state.modalUsuarioIsOpened = isOpened
    },
    TOGGLE_MODAL_USUARIO_PORTAL(state) {
        state.modalUsuarioPortalIsOpened = !state.modalUsuarioPortalIsOpened
    },
    TOGGLE_MODAL_HISTORICO(state) {
        state.modalHistoricoIsOpened = !state.modalHistoricoIsOpened
    },
    SET_MODAL_HISTORICO(state, isOpened) {
        state.modalHistoricoIsOpened = isOpened
    },
    SET_TOTAL_NOTIFICACAO(state,valor) {
        state.totalNotificacao = valor;
    },
    SET_TOTAL_MENSAGENS(state,valor) {
        state.totalMensagens = valor;
    },         

} 

export default { 
    namespaced: true,
    state,
    mutations 
}
